import React from 'react';
import { motion } from 'framer-motion';
import { Car, Trees, Home, Hammer, KeyRound, HeartHandshake } from 'lucide-react';
const outcomes = [{
  icon: Car,
  text: 'You walk into the garage and — for the first time in years — there\'s real, usable space.'
}, {
  icon: Trees,
  text: 'The backyard looks like a backyard again.'
}, {
  icon: Home,
  text: 'The property is clean, photographed, and ready to list.'
}, {
  icon: Hammer,
  text: 'The contractor can finally start the next phase.'
}, {
  icon: KeyRound,
  text: 'The tenant space is clean and rentable again.'
}, {
  icon: HeartHandshake,
  text: 'The estate is cleared and the family can move forward.'
}];
export function LifeBack() {
  return <section className="py-20 lg:py-28 bg-white border-y border-gray-200" data-id="element-378" data-mp="1da9e3z0xkjvy">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-379" data-mp="3a4e02l9xejpp">
        <div className="max-w-3xl mb-14" data-id="element-380" data-mp="3a676q0kjh3xp">
          <motion.span initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-[11px] tracking-[0.25em] font-bold uppercase text-[#C8102E] block mb-4" data-id="element-381" data-mp="3f25qfaux9xrs">
            After The Truck Pulls Away
          </motion.span>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} className="text-4xl md:text-5xl font-bold text-[#1A1A1A] leading-[1.05]" data-id="element-382" data-mp="3bzr8bm1xtw0">
            THE LIFE YOU GET BACK
            <br data-id="element-383" data-mp="m1octe40jxyp" />
            <span className="text-[#C8102E]" data-id="element-384" data-mp="m16dg8m213mk">WHEN IT'S GONE</span>
          </motion.h2>
        </div>

        <ul className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-16" data-id="element-385" data-mp="hzb4chxvtly8">
          {outcomes.map((outcome, i) => {
          const Icon = outcome.icon;
          return <motion.li key={i} initial={{
            opacity: 0,
            y: 16
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: i * 0.06,
            duration: 0.45,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex flex-col bg-[#F9F9F9] border border-gray-200 rounded-2xl p-6" data-id="element-386" data-mp="32qttck8eqa3o" data-mpi={i}>
                <span className="flex w-11 h-11 rounded-xl bg-white border border-gray-200 items-center justify-center text-[#C8102E] mb-5" data-id="element-387" data-mp="2zaqwuhhir0u2">
                  <Icon size={20} data-id="element-388" data-mp="2q8hp1zdmxlkd" />
                </span>
                <p className="text-[15px] text-gray-700 leading-relaxed" data-id="element-389" data-mp="2qa2itms4l0h6">
                  {outcome.text}
                </p>
              </motion.li>;
        })}
        </ul>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-center max-w-3xl mx-auto" data-id="element-390" data-mp="2gifwove91gzn">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-gray-400 mb-5" data-id="element-391" data-mp="1nwq0i4mf6d9g">
            That's what we're really selling you
          </p>
          <p className="font-oswald text-4xl md:text-6xl text-[#1A1A1A] leading-[1.05]" data-id="element-392" data-mp="1wwczkjrof6zc">
            NOT JUNK REMOVAL.
            <br data-id="element-393" data-mp="1rwrzu74omulk" />
            <span className="text-[#C8102E]" data-id="element-394" data-mp="1rw8hwqf1867j">
              SPACE. PEACE OF MIND. A FRESH START.
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}